import PropTypes from 'prop-types'
import { CardTitle } from '@usb-ui-tools/react-billpay-layout'
import { useMultilingualService } from '../../../../../service/multilingualService'
import { isOLBOrIpadApp } from '../../../../../utils/browserutils'

/**
 * @typedef {Object} search error
 */
/**
 * Returns Manual Header
 * @function
 * @param {func} onAddbillManually - locale of search error
 * @returns {HTMLElement} Returns error message with redirection link
 */

const ManualHeader = ({ isFieldsValidationError, pageErrorMsg }) => {
  const { HEADER } = useMultilingualService('addBillManual')

  return (
    <CardTitle
      {...{
        notificationArray: [
          {
            type: 'error',
            message: pageErrorMsg || `${HEADER?.ADD_BILL_PAGE_ERROR}`,
            show: isFieldsValidationError
          }
        ],

        showAvatar: false,
        pageTitleText: HEADER?.ADD_BILL_MANUALLY_HEADER,
        id: 'add-bill-manual',
        isOLBOrIpadApp,
        cardTitleTextSameAsPageTitleText: true,
        gapThruMarginTop: true
      }}
    />
  )
}

ManualHeader.propTypes = {
  isFieldsValidationError: PropTypes.bool.isRequired,
  pageErrorMsg: PropTypes.string.isRequired
}

export default ManualHeader
